import { ObjectAccessRights, AccessRights, Category, IGuid } from '../../../models';
import { DashboardThumbnailWidget } from '../../../widgets/dashboardThumbnail/dashboardThumbnail.widget';

export function mapRigths(rights: { [guid: string]: ObjectAccessRights },
    widgetList: DashboardThumbnailWidget[],
    categoryList: Category[]) {
    const rightsDictionary: { [guid: string]: AccessRights } = {};
    const itemWithRights: IGuid[] = (widgetList as IGuid[]).concat(categoryList as IGuid[]);

    itemWithRights.forEach(w => {
        rightsDictionary[w.guid] = rights[w.guid]
            ? rights[w.guid].accessRights
            : {
                userCollection: [],
                roleCollection: []
            };
    });
    return rightsDictionary;
}